<template>
  <nuttrema-layout-content>
    <template slot="header">
      <persons-standard-header
        :meta="meta"
        :PersonDetails="PersonDetails">
        <template slot="edit">
          <div class="content-header-item">
            <permissions-control-wrapper
              :required-general="$PERMISSIONS_GENERAL.EDIT_PROFILE"
              :permissions="_get(PersonDetails, 'meta.permissions')">
              <edit-lock-button slot="allowed" :edit.sync="edit"></edit-lock-button>
              <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
            </permissions-control-wrapper>
          </div>
        </template>
      </persons-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="PersonDetails.fetching || PersonLifeStages.fetching || RegionalAndLanguageAll.fetching"></nuttrema-loader>
      <form-participant-personal-information-cred
         v-else
        :id="id"
        :edit.sync="edit"
        :PersonDetails="PersonDetails"
        :PersonLifeStages="PersonLifeStages"
        :RegionalAndLanguageAll="RegionalAndLanguageAll"
        @deletePerson="onDeletePerson"
        @submit="onFormSubmit">
      </form-participant-personal-information-cred>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { PERSON_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import PersonsStandardHeader from 'components/pages/professional/persons/participants/shared/blocks/cmpt-persons-standard-header';

import FormParticipantPersonalInformationCred from './form-participant-personal-information-cred';

export default {
  name: 'page-participant-personal-information-view',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      required: false,
      default: PERSON_KEYS.participant,
    },
  },
  components: {
    NuttremaLayoutContent,
    PersonsStandardHeader,
    FormParticipantPersonalInformationCred,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    ...mapGetters([
      'RegionalAndLanguageAll',
    ]),
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
    PersonLifeStages() {
      return this.$store.getters.PersonLifeStages(this.type);
    },
  },
  methods: {
    ...mapActions([
      'DeletePerson',
      'SavePersonDetails',
    ]),
    onFormSubmit(payload) {
      this.SavePersonDetails({
        id: this.id,
        type: this.type,
        payload,
      }).then(() => {
        this.successNotification({ label: 'label.participant' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
    onDeletePerson() {
      this.DeletePerson({
        id: this.id,
        type: this.type,
      })
      .then(() => {
        this.successNotification({ label: 'label.participant', message: 'message.default_success_delete_message' });
        this.onSuccessEvent();
      }).catch(() => {
        this.errorNotification();
      });
    },
  },
  created() {
    this.$store.dispatch('GetRegionalAndLanguageAll', { language_app_support: true, measurement_system_optional: true });
    this.$store.dispatch('GetPersonLifeStages', { type: this.type });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearRegionalAndLanguageAll');
    this.$store.dispatch('ClearPersonLifeStages', { type: this.type });
  },
};
</script>

<style lang="scss" scoped>
  .form {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-cred/page-participant-personal-information-view.vue